import {
  getCourses,
  getCourseById,
  getFeaturedCourses,
  getUserCourses,
} from "./asyncThunks";

export const getCoursesBuilder = (builder) => {
  builder.addCase(getCourses.pending, (state) => {
    state.coursesLoading = true;
    state.error = null;
  });
  builder.addCase(getCourses.fulfilled, (state, action) => {
    state.coursesLoading = false;
    state.courses = action.payload.courses;
    state.error = null;
  });
  builder.addCase(getCourses.rejected, (state, action) => {
    state.coursesLoading = false;
    state.error = action.error.message;
  });
};

export const getCourseByIdBuilder = (builder) => {
  builder.addCase(getCourseById.pending, (state) => {
    state.courseLoading = true;
    state.error = null;
  });
  builder.addCase(getCourseById.fulfilled, (state, action) => {
    state.courseLoading = false;
    state.selectedCourse = action.payload.course;
    state.userCourse = action.payload.userCourse;
    state.hasAccess = action.payload.hasAccess;
    state.error = null;
  });
  builder.addCase(getCourseById.rejected, (state, action) => {
    state.courseLoading = false;
    state.error = action.error.message;
  });
};

export const getFeaturedCoursesBuilder = (builder) => {
  builder.addCase(getFeaturedCourses.pending, (state) => {
    state.featuredLoading = true;
    state.error = null;
  });
  builder.addCase(getFeaturedCourses.fulfilled, (state, action) => {
    state.featuredLoading = false;
    state.featuredCourses = action.payload.courses;
    state.error = null;
  });
  builder.addCase(getFeaturedCourses.rejected, (state, action) => {
    state.featuredLoading = false;
    state.error = action.error.message;
  });
};

export const getUserCoursesBuilder = (builder) => {
  builder.addCase(getUserCourses.pending, (state) => {
    state.userCoursesLoading = true;
    state.userCoursesError = null;
  });
  builder.addCase(getUserCourses.fulfilled, (state, action) => {
    state.userCoursesLoading = false;
    state.userCourses = action.payload.userCourses;
    state.userCoursesError = null;
  });
  builder.addCase(getUserCourses.rejected, (state, action) => {
    state.userCoursesLoading = false;
    state.userCoursesError = action.error.message;
  });
};
